import { render, staticRenderFns } from "./rfq-supplier-part-all.vue?vue&type=template&id=8938da22"
import script from "./rfq-supplier-part-all.vue?vue&type=script&lang=js"
export * from "./rfq-supplier-part-all.vue?vue&type=script&lang=js"
import style0 from "./rfq-supplier-part-all.vue?vue&type=style&index=0&id=8938da22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports